/**
 * Category names for the cashflow panels (P4, ruled in the Tasks 7–9 addendum).
 *
 * `CashflowScreen` is presentational and does not fetch, so names and parents
 * arrive as a prop keyed by category id. The container (Task 10) builds the
 * map from M11's `useCategories()`; the probe builds it from the fixtures. No
 * colour: under the issue-454 ruling M3 draws no category colour, so the
 * container has nothing to map.
 */
export type CategoryInfo = {
  name: string
  parentId: string | null
  icon?: string | null
}

export type CategoryMap = ReadonlyMap<string, CategoryInfo>

export const UNCATEGORISED = 'Uncategorised'
export const OTHER_CATEGORY = 'Other category'

/** `null` is Uncategorised; an id the map does not hold is "Other category", never a crash or a raw id. */
export function categoryName(categories: CategoryMap, id: string | null): string {
  if (id === null) return UNCATEGORISED
  return categories.get(id)?.name ?? OTHER_CATEGORY
}
